import { useTranslation } from 'react-i18next';
import { AlertTriangle, Sparkles } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ReoptimizeConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /**
   * Wie viele der NEUEN Produkte dieses Laufs nicht mehr in den freien
   * Bestand passten und deshalb vom Server bereits abgeschnitten wurden.
   * Optional und meist 0/undefined: der Server sendet dieses Feld erst seit
   * dem Bestandsmass-Umbau ueberhaupt mit, aeltere Antworten und der reine
   * Wiederholungsfall (keine neuen Produkte im Lauf) kennen es nicht. Nur bei
   * einer echten positiven Zahl erscheint der Hinweis ueberhaupt.
   */
  droppedNew?: number;
}

export function ReoptimizeConfirmDialog({ open, onClose, onConfirm, droppedNew }: ReoptimizeConfirmDialogProps) {
  const { t } = useTranslation('enforcement');
  const handleOpenChange = (v: boolean) => { if (!v) onClose(); };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-warning" />
            {t('reoptimize.title')}
          </DialogTitle>
          <DialogDescription>{t('reoptimize.description')}</DialogDescription>
        </DialogHeader>

        {/* Nur zeigen, wenn der Server wirklich neue Produkte abgeschnitten
            hat. Der Feed-Deckel selbst zaehlt still weiter und sperrt nicht
            mehr — die frueher hier gezeigte Restzahl-Warnung ("Noch 0 erneute
            Optimierungen fuer diesen Feed uebrig") ist damit ersatzlos weg. */}
        {!!droppedNew && droppedNew > 0 && (
          <div className="rounded-lg border border-warning/30 bg-warning-light p-3 text-sm text-warning-ink">
            {t('reoptimize.droppedNewHint', { count: droppedNew })}
          </div>
        )}

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} className="sm:w-auto">
            {t('reoptimize.cancel')}
          </Button>
          <Button onClick={onConfirm} className="sm:w-auto gap-2">
            <Sparkles className="h-4 w-4" />
            {t('reoptimize.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
